import { Col, Typography } from '@lightbeamai/design-system'
import { CaretRight, Check, X } from 'phosphor-react'
import React from 'react'

export interface StepConfig {
  text?: string | React.ReactNode
  enabled?: boolean
  isStepCompleted?: boolean
}

export interface StepperProps {
  title: string | React.ReactNode
  titleActions?: React.ReactNode
  steps: string[] | StepConfig[]
  activeStep: number
  onChange?: (step: number) => void
  showStepper?: boolean
  onClose?: () => void
  wideStep?: boolean
}

const Stepper = (props: StepperProps) => {
  const {
    steps,
    activeStep,
    title,
    titleActions,
    onChange: onStepChange,
    showStepper = true,
    onClose,
    wideStep = false
  } = props

  const Title =
    typeof title === 'string' ? (
      <Typography type="strong" variant="basePlus2">
        {title}
      </Typography>
    ) : (
      title
    )

  return (
    <div className="stepper-wrapper">
      <Col span={!showStepper ? 6 : wideStep ? 2 : 3}>
        <div className="stepper-title">{Title}</div>
      </Col>
      {showStepper && (
        <Col span={wideStep ? 8 : 6} className="stepper-steps">
          <>
            {steps.map((step, index) => {
              const isStringStep = typeof step === 'string'
              const stepText = isStringStep ? step : step.text
              const enabled = isStringStep ? true : step.enabled !== false
              const isStepCompleted = isStringStep ? false : step.isStepCompleted

              return (
                <div
                  onClick={() => enabled && onStepChange?.(index)}
                  className={`stepper-step ${activeStep === index ? 'active' : ''} ${
                    enabled ? '' : 'disabled'
                  }`}
                  key={`step-${index}`}
                >
                  {isStepCompleted && <Check size={18} className="xs-mr-8" color="#3E21EE" />}
                  <Typography
                    className="step-text xs-mb-0"
                    type={activeStep === index ? 'strong' : 'normal'}
                  >
                    {index + 1}. {stepText}
                  </Typography>
                  {index < steps.length - 1 && (
                    <CaretRight size={20} className="stepper-step-icon" />
                  )}
                </div>
              )
            })}
          </>
        </Col>
      )}
      <Col span={wideStep ? 2 : 3} className="stepper-close-btn-wrapper">
        {titleActions}
        {onClose && (
          <div className="stepper-close-btn" onClick={onClose}>
            <X size={20} />
          </div>
        )}
      </Col>
    </div>
  )
}

export default Stepper
